import { PROJECT_UNIT_DELETE_CONFIRM, PROJECT_UNIT_DELETE_CONFIRM_DECLINE, PROJECT_UNIT_DELETE_FAILURE, PROJECT_UNIT_DELETE_SUCCESS, PROJECT_UNIT_EDIT_PAGE_SUCCESS, PROJECT_UNITS_FAILURE, PROJECT_UNITS_REQUEST, PROJECT_UNITS_SUCCESS } from "../../redux/action_constant";
import { ProjectActions, ProjectUnitInterface, ProjectUnitState } from "./ProjectUnitTypes";


const initialState: ProjectUnitState = {
    pending: false,
    error: null,
    loading: false,
    projectList: [] as ProjectUnitInterface[],
    next_offset: 0,
    listCount: 0,
    editProject: {} as ProjectUnitInterface,
    showDeleteModal: false,
    deleteProject: {} as ProjectUnitInterface,
};

const ProjectUnitReducer = (state = initialState, action: ProjectActions) => {
    switch (action.type) {
        case PROJECT_UNITS_REQUEST:
            return {
                ...state,
                loading: true,
                editProject: {} as ProjectUnitInterface,
                showDeleteModal: false,
                deleteProject: {} as ProjectUnitInterface,
            };
        case PROJECT_UNITS_SUCCESS:
            return {
                ...state,
                loading: false,
                projectList: action.payload.list,
                next_offset: action.payload.next_offset,
                listCount: action.payload.count,
                error: null,
            };
        case PROJECT_UNITS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
                projectList: [],
                next_offset: -1,
                listCount: 0,
            };
        case PROJECT_UNIT_EDIT_PAGE_SUCCESS:
            return {
                ...state,
                editProject: action.payload,
            };
        case PROJECT_UNIT_DELETE_CONFIRM:
            return {
                ...state,
                showDeleteModal: true,
                deleteProject: action.payload,
            };
        case PROJECT_UNIT_DELETE_CONFIRM_DECLINE:
            return {
                ...state,
                showDeleteModal: false,
                deleteProject: {} as ProjectUnitInterface,
            };
        case PROJECT_UNIT_DELETE_FAILURE:
            return {
                ...state,
                showDeleteModal: false,
                deleteProject: {} as ProjectUnitInterface,
            };
        case PROJECT_UNIT_DELETE_SUCCESS:
            return {
                ...state,
                showDeleteModal: false,
                deleteProject: {} as ProjectUnitInterface,
            };
        default:
            return {
                ...state,
            };
    }
};

export default ProjectUnitReducer;   